import React from "react";
const dailyItemsCode = require('../../data/daily/dailyItemsCode.json');


const typeData = [
  {
    "title": ["蔬菜", "vegitables"],
    "items": [
      ["根莖菜類", "rootAndStem"],
      ["葉菜類", "leafy"],
      ["花果菜類", "flowersAndFruits"],
      ["菇菌類", "mushroom"],
      ["醃製類", "overcured"]
    ]
  },
  {
    "title": ["水果", "fruits"],
    "items": [
      ["水果類", "fruits"]
    ]
  }
];


class DailyItemSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadItemDetailArray: [],
      dataSet: {},
      typeSelected: '',
      itemSelected: ''
    }
    this.showItemDetails = this.showItemDetails.bind(this);
    this.handleItemSelected = this.handleItemSelected.bind(this);
    this.showSearchDetailSelections = this.showSearchDetailSelections.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.props.loadData !== prevProps.loadData) {
      this.setState({
        loadItemDetailArray: [],
        dataSet: {},
        typeSelected: '',
        itemSelected: ''
      });
    }

    if (this.state.typeSelected !== prevState.typeSelected) { //** different
      this.setState({
        itemSelected: ''
      });
    }
  }

  showItemDetails(catalog, item) {
    this.setState({
      loadItemDetailArray: Object.keys(dailyItemsCode[catalog][item]),
      //  parameter: 'crop',
      dataSet: dailyItemsCode[catalog][item],
      typeSelected: item
    });
  }

  handleItemSelected(itemMainCode) {
    this.setState({
      itemSelected: itemMainCode
    })
  }

  showSearchDetailSelections() {
    let buttons = [];
    let selections = [];
    let currentSelectedItem = '';

    this.state.loadItemDetailArray.forEach((itemMainCode, index) => {
  
      buttons.push(
        <li key={ index + itemMainCode } className={this.state.itemSelected === itemMainCode ? "btnOn" : "btnOff"} 
        onClick={ () => {
          this.props.onChange('crop', this.state.dataSet[itemMainCode]['itemsCode']);
          this.handleItemSelected(itemMainCode);
        } }> { this.state.dataSet[itemMainCode]['itemName'] } </li> 
        //** call onChange event in daily.js as a props for <DailyItemSearch> 
      );

      selections.push(
        <option key={ index + itemMainCode } className='selection' value={ itemMainCode }
        >{index + 1}. { this.state.dataSet[itemMainCode]['itemName'] } </option>
      );
    });

    typeData.forEach((type) => {
      type.items.forEach((item) => {
        if (item[1] === this.state.typeSelected) {
          currentSelectedItem = item[0];
        }
      });
    });

    return {
      'buttons': buttons,
      'selections': selections,
      'currentSelectedItem': currentSelectedItem
    }
  }


  render() {
    if (this.props.loadData) {
      return (
        <div id="DailyItemSearch">
          <div id="daily-search-detail-selection-btn">
            { typeData.map((type) => {
              
                return (
                  <div key={ type['title'][1] } className="daily-search-type-selection">
                    <div className="typeTitle">{type.title[0]}</div>
                    <ul>{type.items.map((item) => {
                      return (
                        <li key={ item[1] } className={this.state.typeSelected === item[1] ? "btnOn" : "btnOff"} onClick={() => this.showItemDetails(type.title[1], item[1])}>{ item[0] }</li>
                       )
                      })}
                    </ul>
                  </div>
                );
            }) }
          </div>

          <div id="daily-search-detail-selection-more">
            <ul className={this.state.loadItemDetailArray.length === 0 ? "unloadData" : "loadData"}> 
              {this.showSearchDetailSelections()['buttons']}
            </ul>

            <select className="selection" 
              onChange={(event) => { 
                if (event.target.value !== '-') {
                  this.props.onChange('crop', this.state.dataSet[event.target.value]['itemsCode']);
                  this.handleItemSelected(event.target.value);
                } }} 
                value={this.state.itemSelected === '' ? this.state.itemSelected : this.state.itemSelected}>

              <option className="selection" defaultValue value='-' >-- 請選擇{this.showSearchDetailSelections()['currentSelectedItem']} --</option>

             { this.showSearchDetailSelections()['selections'] }
            </select>
          </div>
        </div>
      );
    } else {
      return (
        <div></div>
      );
    }
  }
};


const marketData = [
  {
    "types": ["蔬菜市場", "vegetableMarkets"],
    "items": [
      {
        "position": ["北部", "north"],
        "markets": [
          ["台北一", "109"],
          ["台北二", "104"],
          ["三重", "241"],
          ["桃園", "338"],
          ["宜蘭", "260"]
        ]
      },
      {
        "position": ["中部", "center"],
        "markets": [
          ["台中", "400"],
          ["豐原", "420"],
          ["南投", "540"],
          ["永靖", "512"],
          ["溪湖", "514"],
          ["西螺", "648"]
        ]
      },
      {
        "position": ["南部", "south"],
        "markets": [
          ["高雄", "800"],
          ["鳳山", "830"],
          ["屏東", "900"]
        ]
      },
      {
        "position": ["東部", "east"],
        "markets": [
          ["台東", "930"],
          ["花蓮", "950"]
        ]
      }
    ]
  },
  {
    "types": ["水果市場", "fruitMarkets"],
    "items": [
      {
        "position": ["北部", "north"],
        "markets": [
          ["台北一", "109"],
          ["台北二", "104"],
          ["三重", "241"],
          ["桃園", "338"],
          ["宜蘭", "260"]
        ]
      }, {
        "position": ["中部", "center"],
        "markets": [
          ["台中", "400"],
          ["豐原", "420"],
          ["東勢", "423"],
          ["南投", "540"]
        ]
      }, {
        "position": ["南部", "south"],
        "markets": [
          ["嘉義", "600"],
          ["高雄", "800"],
          ["鳳山", "830"]
        ]
      }, {
        "position": ["東部", "east"],
        "markets": [
          ["台東", "930"],
        ]
      }
    ]
  }
];


class DailyMarketSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadData: '',
      marketSelected: '',
      marketDataSet: []
    }
    
    this.loadMarketData = this.loadMarketData.bind(this);
    this.handleMarketClicked = this.handleMarketClicked.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadData !== prevProps.loadData) {
      this.setState({
        loadData: '',
        marketSelected: '',
        marketDataSet: []
      });
    }
  }

  loadMarketData(marketType) {
    switch (marketType) {
      case 'vegetableMarkets':
        this.setState({
          loadData: marketType,
          marketDataSet: marketData[0]['items']
        });
        break;

      case 'fruitMarkets':
        this.setState({
          loadData: marketType,
          marketDataSet: marketData[1]['items']
        });
        break;

      default: 
        this.setState({
          loadData: '',
          marketDataSet: marketData[0]['items']
        });
        break;
    }
  }

  handleMarketClicked(marketPosition) {
    this.setState({
      marketSelected: marketPosition
    });
  }
  
  render() {
    if (this.props.loadData) {
      return ( 
        <div id="DailyMarketSearch">
          <ul id="loadMarketTypes">
            { marketData.map((market) => {
              return (
                <li className={this.state.loadData === market['types'][1] ? "btnOn" : "btnOff" } onClick={ () => this.loadMarketData(market['types'][1]) }>{ market['types'][0] }</li>
              );
            }) }
          </ul>

          <div id="markets">
            { this.state.marketDataSet.map((market) => {
                return (
                  <div className="daily-search-market-selection">
                    <div className="marketDirection">{ market['position'][0] }</div>
                    <ul>
                      { market['markets'].map((marketPosition) => {
                        return (
                          <li className={this.state.marketSelected === marketPosition[0] ? "btnOn" : "btnOff"} 
                              onClick={ () => {
                                this.props.onChange('market', marketPosition[0]); 
                                this.handleMarketClicked(marketPosition[0]);} 
                          }>{ marketPosition[0] }</li>
                        );
                      }) }
                    </ul>
                  </div>
                );
              }) }
          </div>
        </div> );
    } 
    else {
      return (<div></div>);
    }
  }
};


class DailyCodeSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValueExist: true
    }
    this.handleSubmitBtn = this.handleSubmitBtn.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadData !== prevProps.loadData) {
      this.setState({
        inputValueExist: true
      });
    }
  }

  handleSubmitBtn() {
    let codeVal = document.getElementById('codeSearchInput').value.toUpperCase();

    //** Check if input value is exit
    let titles = Object.keys(dailyItemsCode);
    let lastType = dailyItemsCode[titles[titles.length - 1]];
    let items = lastType[Object.keys(lastType)[Object.keys(lastType).length - 1]];
    let LastItemCode = Object.keys(items)[Object.keys(items).length - 1];
    let lastItemCode = items[LastItemCode]['itemsCode'][items[LastItemCode]['itemsCode'].length - 1]
    let findOut = false;

    titles.forEach((title) => {
      let types = Object.keys(dailyItemsCode[title]);
      types.forEach((type) => {
        let mainCodes = Object.keys(dailyItemsCode[title][type]);
        mainCodes.forEach((mainCode) => {
          let itemCodes = dailyItemsCode[title][type][mainCode]['itemsCode'];
          let findResult = itemCodes.indexOf(codeVal);

          if (findResult !== -1) {  //** code exist
            this.props.onChange('CropCode', codeVal);
            console.log('Exist');
            findOut = true;
            this.setState({
              inputValueExist: true
            });
          } 
          else if ((lastItemCode === itemCodes[itemCodes.length - 1]) && (findOut === false)) {
            console.log("Input value doesn't exist!");
            this.setState({
              inputValueExist: false
            })
          }
        })
      });
    })
  }

  render() {
    if (this.props.loadData) {
      return (
        <div id="DailyCodeSearch">
          <input id="codeSearchInput" type="input" name="code" placeholder="請輸入農產品代碼" required/>
          <button id="codeSubmitBtn" onClick={() => this.handleSubmitBtn()} > 查詢批發價格 </button>

          { (this.state.inputValueExist) ? null : <p className="searchResultMsg">查無此代號！</p> }
        </div>
      );
    } 
    else {
      return (<div></div>)
    }
  }
}


const findAllItemName = () => {
  let titles = Object.keys(dailyItemsCode);
  let itemNames = [];

  titles.forEach((title) => {
    let types = Object.keys(dailyItemsCode[title]);
    types.forEach((type) => {
      let mainCodes = Object.keys(dailyItemsCode[title][type]);
      mainCodes.forEach((mainCode) => {
        itemNames.push([dailyItemsCode[title][type][mainCode]['itemName'], dailyItemsCode[title][type][mainCode]['itemsCode']]);    
      }); 
    });
  });

  return itemNames;
}


class DailyKeywordSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = ({
      itemNameDataSet: [],
      searchResultData: [],
      itemSelected: ''
    });
    this.handleSubmitBtn = this.handleSubmitBtn.bind(this);
    this.handleKeywordSearch = this.handleKeywordSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadData !== prevProps.loadData) {
      this.setState({
        searchResultData: [],
        itemSelected: ''
      });
    }
  }

  componentDidMount() {
    this.setState({
      itemNameDataSet: findAllItemName()
    })
  }

  handleSubmitBtn() {
    let inputKeyword = document.getElementById('keywordSearchInput').value;
    let dataSet = this.state.itemNameDataSet;
    let searchResult = [];
    
    if (inputKeyword !== '') {
      for (var i = 0; i < dataSet.length; i++) {
        if (dataSet[i][0].indexOf(inputKeyword) > -1) {
          searchResult.push(dataSet[i]);
        }
      }
    }

    if (searchResult.length === 0) {
      searchResult = false;
    }

    this.setState({
      searchResultData: searchResult
    });
  }

  handleKeywordSearch(itemCodesData) {
    console.log(itemCodesData);
    this.props.onChange('crop', itemCodesData);

    this.setState({
      itemSelected: itemCodesData
    })
  }

  render() {
    if (this.props.loadData) {
      return (
        <div id="DailyKeywordSearch">
          <div id="DailyKeywordSearchInputBoard">
            <input id="keywordSearchInput" type="input" name="keyword" placeholder="請輸入欲查詢關鍵字" required />
            <button id="keywirdSubmitBtn" onClick={ () => this.handleSubmitBtn() }> 查詢關鍵字 </button>
          </div>

          <div className={this.state.searchResultData.length === 0 || this.state.searchResultData === false ? "unloadData" : "loadData"} id="DailyKeywordSearchResult">
            <ul>
              { this.state.searchResultData.length === 0 || this.state.searchResultData === false ? null : 
                (this.state.searchResultData.map((el) => {
                  return (
                    <li className={this.state.itemSelected === el[1] ? "btnOn" : "btnOff"} onClick={() => this.handleKeywordSearch(el[1])}>{ el[0] }</li>
                  );
                }))
              }
            </ul>

            { this.state.searchResultData === false  ? <p className="searchResultMsg">查無關鍵字!</p> : null}
          </div>
        </div>
      );
    } 
    else {
      return (<div></div>);
    }
  }
};

export { DailyItemSearch, DailyMarketSearch, DailyCodeSearch, DailyKeywordSearch };



// WEBPACK FOOTER //
// ./src/components/containers/dailyDetail.js